import { put } from '..';

const editRole = (
  name: string,
  roleDescription: string,
  permissions: string[],
  roleId: string,
  roleColor: string,
) => put(
  `users/roles/${roleId}`,
  {
    name,
    description: roleDescription,
    permissions,
    roleId,
    color: roleColor,
  },
);

export default editRole;
